import { Chat } from '@features/components/Chat';
import { ChatConnectionGate } from '@features/components/Chat/components/ChatConnectionGate';
import { StreamChatShareProvider } from '@features/components/Chat/contexts/ChatShareContext';
import { useChatFilters } from './hooks/useChatFilters';

export const ChatHub = () => {
  const filterState = useChatFilters();

  return (
    <ChatConnectionGate>
      <StreamChatShareProvider>
        <Chat filterState={filterState} inlineLayout />
      </StreamChatShareProvider>
    </ChatConnectionGate>
  );
};
